import Localize from 'app/src/localize/Localize';
import { escapeHtml } from 'root/html';

import { Customer, GiftCard } from './types';

export function renderGiftCardInput(
  giftCard: GiftCard,
  customer: Customer | undefined,
  codeInput: string,
  showInput: boolean
): string {
  const customerName = customer
    ? `${customer.firstName} ${customer.lastName}`
    : Localize.translate('No customer is attached to the card');

  const escapedCode = escapeHtml(giftCard.code);

  let input = `<div class="ogc-select-container cr-flex cr-justify-between cr-items-center">
                  <p class="ogc-select-label cr-flex cr-items-center">${escapedCode}</p>
                  <div class="ogc-select cr-flex cr-items-center">
                      <input required
                        type="${showInput ? 'radio' : 'hidden'}"
                        name="code"
                        class="ogc-select-input"
                        ${giftCard.code === codeInput && showInput ? 'checked' : ''}
                        value="${escapedCode}"
                        data-uuid="${giftCard.uuid ?? ''}"
                      >
                      <label>${
                        giftCard.createdAt
                          ? Localize.translate('Recharge')
                          : Localize.translate('Create')
                      }</label>
                  </div>
              </div>`;

  if (giftCard.createdAt) {
    input = `<p class="ogc-customer notranslate">
                 ${escapeHtml(customerName)}
             </p>${input}`;
  }

  return input;
}

export function updateGiftCardResults(content: string): void {
  const selectElement = document.getElementById('custom-gc-select');

  if (selectElement) {
    selectElement.innerHTML = `
      <div class="fl-input-label ogc-optional">
        <label>${Localize.translate('Gift Card Results')}</label>
      </div>${content}`;
  }
}

export function resetGiftCardResults(): void {
  const selectElement = document.getElementById('custom-gc-select');

  if (selectElement) {
    selectElement.innerHTML = '';
  }
}

export function resetCodeInput(): void {
  const input = document.getElementById('new_gift_card_code') as HTMLInputElement | null;
  if (input) {
    input.value = '';
  }
}
